<template>
  <span>
    <template v-for="input of inputs">
      <sidebar-form-row
        v-if="!input.hidden"
        @appendIconClicked="$emit('appendIconClicked', $event)"
        :has-append-icon="hasAppendIcon"
        v-bind="input"
        :class="input.divided ? 'border-bottom pb-2 mb-2' : ''"
        :key="input.name"
        :hasIconColumn="hasIconColumn"
        :is-editing-on="isEditingOn"
        v-model="value[input.name]"
      >
        <template v-for="(value, key) in $scopedSlots" #[key]="scope">
          <slot :name="key" v-bind="{ ...scope, ...$props.inputs.find(input => input.name === key), isEditingOn }" />
        </template>
      </sidebar-form-row>
    </template>
  </span>
</template>

<script>
import SidebarFormRow from '@/components/SidebarFormRow';

export default {
  name: 'SidebarForm',
  components: {
    SidebarFormRow,
  },
  props: {
    inputs: {
      type: Array,
      default: () => [],
    },
    isValid: {
      type: Boolean,
      default: false,
    },
    isEditingOn: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      required: true,
    },
    hasIconColumn: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    computedIsValid: {
      get() {
        return this.isValid;
      },
      set(nV) {
        this.$emit('update:isValid', nV);
      },
    },
    hasAppendIcon() {
      return this.inputs.some(input => input.appendIcon);
    },
  },
};
</script>
<style lang="scss" scoped>
.border-bottom {
  @include border(bottom);
}
</style>
